<template>
  <div class="container-fluid py-4 px-4">
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-8">
            <div class="card">
              <form @submit.prevent="thisChangePassword">
                <div class="card-body">
                  <h5 class="card-title font-weight-bold">
                    Change password
                  </h5>

                  <hr>

                  <div class="row">
                    <div class="col-5">

                      <label class="col-form-label font-weight-bold">Password Details</label>

                      <hr>

                      <!-- new password -->
                      <div class="form-group">
                        <label for="old-password" class="col-form-label">Old Password</label>
                        <div class="input-group input-group-sm">
                          <input type="password"
                                 class="form-control form-control-sm"
                                 id="old-password"
                                 aria-describedby="emailHelp"
                                 :disabled="!isEditable"
                                 v-model="passwordData.oldPassword"
                                 required
                                 placeholder="Enter old password">

                          <div class="input-group-append">
                            <button class="btn btn-sm btn-secondary" type="button" title="Show Password"
                                    :disabled="!isEditable"
                                    @click="showPassword(1)">
                              <font-awesome-icon :icon="this.iconOld" />
                            </button>
                          </div>

                        </div>
                      </div>

                      <!-- new password -->
                      <div class="form-group">
                        <label for="new-password" class="col-form-label">New Password</label>
                        <div class="input-group input-group-sm">
                          <input type="password"
                                 class="form-control form-control-sm"
                                 id="new-password"
                                 aria-describedby="emailHelp"
                                 :disabled="!isEditable"
                                 v-model="passwordData.newPassword"
                                 required
                                 placeholder="Enter new password">

                          <div class="input-group-append">
                            <button class="btn btn-sm btn-secondary" type="button" title="Show Password"
                                    :disabled="!isEditable"
                                    @click="showPassword(2)">
                              <font-awesome-icon :icon="this.iconNew" />
                            </button>
                          </div>

                        </div>
                      </div>

                      <!-- confirm password -->
                      <div class="form-group">
                        <label for="new-password" class="col-form-label">Confirm password</label>
                        <div class="input-group input-group-sm">
                          <input type="password"
                                 class="form-control form-control-sm"
                                 id="confirm-password"
                                 aria-describedby="emailHelp"
                                 :disabled="!isEditable"
                                 v-model="passwordData.confirmPassword"
                                 placeholder="Confirm new password">

                          <div class="input-group-append">
                            <button class="btn btn-sm btn-secondary" type="button" title="Show Password"
                                    :disabled="!isEditable"
                                    @click="showPassword(3)">
                              <font-awesome-icon :icon="this.iconConfirm" />
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>

                    <div class="col-7 border-left">
                      <label class="col-form-label font-weight-bold">Systems</label>
                      <hr>
                      <ul class="list-unstyled py-2">
                        <li class="media" v-if="authPos.id != 2 " v-for="(system,index) in authUserSystems"
                            :key="system.id">
                          <img class="mr-3" :src="logo" alt="Generic placeholder image">
                          <div class="media-body">
                            <small class="mt-0 mb-1">{{ system.name.toUpperCase() }}</small>
                          </div>
                        </li>

                        <li class="media" v-if="authPos.id == 2">
                          <img class="mr-3" :src="logo" alt="Generic placeholder image">
                          <div class="media-body">
                            <small class="mt-0 mb-1">TURN OVER NOTES SYSTEM</small>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <p class="card-text text-center mt-5">
                    <small class=" text-danger font-weight-bold">** NOTE CHANGED PASSWORD WOULD TAKE EFFECT IN ALL
                                                                 LISTED SYSTEMS **</small>
                  </p>
                </div>

                <div class="card-footer text-left">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                    <div v-if="!isEditable">
                      <button type="button" class="btn btn-sm btn-secondary mr-1" @click="goBack">
                        <font-awesome-icon icon="undo" />
                        Go Back
                      </button>
                      <button type="button" class="btn btn-sm btn-warning mr-1" @click="thisEdit">
                        <font-awesome-icon icon="edit" />
                        Edit
                      </button>
                    </div>
                    <div v-if="isEditable">
                      <button type="submit" class="btn btn-sm btn-success mr-1">
                        <font-awesome-icon icon="save" />
                        Save
                      </button>
                      <button type="button" class="btn btn-sm btn-secondary mr-1" @click="thisCancel">
                        <font-awesome-icon icon="ban" />
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import krbsLogo from '../../assets/krbsicon.png';
import {AppMixins} from '../../mixins/app.mixins';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'ChangePassword',

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      iconOld: 'eye-slash',
      iconNew: 'eye-slash',
      iconConfirm: 'eye-slash',
      logo: krbsLogo,
      isEditable: false,
      passwordData : {
        oldPassword : null,
        newPassword : null,
        confirmPassword : null,
      },
    };
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
            'changePassword'
        ]
    ),

    thisEdit() {
      this.isEditable = !this.isEditable;
    },

    thisCancel() {
      this.isEditable = !this.isEditable;
    },

    showPassword(__type) {
      let input = null;
      switch (__type) {
        case 1:
          input = document.getElementById('old-password');
          if (input.type == 'password') {
            input.type = 'text';
            this.iconOld = 'eye';

          } else {
            input.type = 'password';
            this.iconOld = 'eye-slash';
          }
          break;

        case 2:
          input = document.getElementById('new-password');
          if (input.type == 'password') {
            input.type = 'text';
            this.iconNew = 'eye';

          } else {
            input.type = 'password';
            this.iconNew = 'eye-slash';
          }
          break;

        case 3:
          input = document.getElementById('confirm-password');

          if (input.type == 'password') {
            input.type = 'text';
            this.iconOld = 'eye';

          } else {
            input.type = 'password';
            this.iconOld = 'eye-slash';
          }
          break;
      }
    },

    async thisChangePassword() {
      let qMsgHtml = '<span>Are you sure you change password ? <br /> This will also change your password on other systems</span>';
      if (await this.questionFormAlert(`${qMsgHtml}`, 'Change Password')) {
        this.changePassword(this.passwordData).then((r) => {
          if (r) {
            this.passwordData = {
              oldPassword: null,
              newPassword: null,
              confirmPassword: null,
            }
          }
        })
      }
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'authUserSystems',
          'authPos',
          'vesselid',
        ],
    ),
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
  },

};
</script>

<style scoped>
img {
  max-height: 20px !important;
  max-width: 20px !important;
}
</style>
